/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarTireDtoFromJSON, CarTireDtoToJSON, } from './';
export function CarSeasonTireDtoFromJSON(json) {
    return CarSeasonTireDtoFromJSONTyped(json, false);
}
export function CarSeasonTireDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'frontTire': !exists(json, 'frontTire') ? undefined : CarTireDtoFromJSON(json['frontTire']),
        'backTire': !exists(json, 'backTire') ? undefined : CarTireDtoFromJSON(json['backTire']),
        'hasRim': !exists(json, 'hasRim') ? undefined : json['hasRim'],
    };
}
export function CarSeasonTireDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'frontTire': CarTireDtoToJSON(value.frontTire),
        'backTire': CarTireDtoToJSON(value.backTire),
        'hasRim': value.hasRim,
    };
}
